export default __webpack_public_path__ + "static/media/wellsFargo.7f629ecf.svg";